import React, { useContext } from 'react';
import { SiteContext } from '@arcteryx/components-contexts';
import { priceFormat } from '@arcteryx/js-price';

const Price = _ref => {
  let {
    price,
    currency,
    className
  } = _ref;
  const {
    country,
    language
  } = useContext(SiteContext);
  const formattedPrice = priceFormat(price, currency, country, language);
  return /*#__PURE__*/React.createElement("span", {
    className: className
  }, formattedPrice);
};

export { Price as default };
//# sourceMappingURL=index.js.map
